import { ReactNode } from "react";
import { DateOnly } from "src/utils/dates";
import { Css } from "~generated/css";
import { Maybe } from "~generated/graphqlTypes";
import { useTestIds } from "~utils";

export type CommonOptionCardProps = {
  title?: ReactNode;
  titleAction?: {
    onClick: () => void;
    triggerText: ReactNode;
    size?: "sm" | "md";
  };
  infoTooltip?: string;
  description?: ReactNode;
  contrast?: boolean;
  cutoffDate?: Maybe<DateOnly>;
};

export const cardVariants = {
  closed: {
    delayChildren: 0,
    staggerChildren: 0,
    transition: {
      staggerChildren: 0,
      delayChildren: 0,
    },
  },
  open: {
    delayChildren: 0,
    staggerChildren: 0,
    transition: {
      staggerChildren: 0.0,
      delayChildren: 0.0,
      bounce: 0,
    },
  },
};

type TitleActionTextProps = {
  triggerText: ReactNode;
  onClick: () => void;
  contrast?: boolean;
  size?: "sm" | "md";
};

// Mainly triggers overlays
export function TitleActionText(props: TitleActionTextProps) {
  const { triggerText, onClick, contrast = false, size = "md" } = props;
  const tid = useTestIds(props, "title-action-text");
  return (
    <span
      css={{
        ...Css.t14.gray.if(contrast).lightGray.$,
        ...Css.if(size === "sm").t10.$,
      }}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      {...tid}
    >
      {triggerText}
    </span>
  );
}
